import { Link } from 'react-router-dom'
import Navbar from '../components/Navbar'
import SEO from '../components/SEO'

export default function AboutPage() {
  return (
    <div style={{ minHeight: '100vh', background: 'var(--bg)' }}>
      <SEO title="About Verse" description="Learn about Verse — a social writing platform built for storytellers, fanfic writers, and readers." />
      <Navbar />

      {/* Hero */}
      <div className="about-hero">
        <div className="about-hero__inner">
          <div className="about-hero__badge">About Verse</div>
          <h1 className="about-hero__title">A home for every story</h1>
          <p className="about-hero__sub">
            Verse is a creative writing platform built for writers and readers who believe stories matter —
            fanfiction, original fiction, poetry, and everything in between.
          </p>
        </div>
      </div>

      <div className="about-body">

        {/* Mission */}
        <section className="about-section">
          <h2 className="about-h2">Our mission</h2>
          <p>
            We built Verse because great stories deserve a great home. Too many writing communities
            feel clinical, cluttered, or hostile to the kinds of stories people actually want to write.
            We wanted something different — a platform where fan creativity is celebrated, original voices
            are amplified, and readers can find exactly what they're looking for.
          </p>
          <p>
            Verse is built around one idea: writing is for everyone. Whether you've been publishing
            fanfic for fifteen years or you're sharing your first original chapter today, you belong here.
          </p>
        </section>

        {/* Values */}
        <section className="about-section">
          <h2 className="about-h2">What we stand for</h2>
          <div className="about-values">
            <div className="about-value">
              <div className="about-value__icon">✍️</div>
              <div>
                <div className="about-value__title">Writers first</div>
                <p className="about-value__desc">
                  Every product decision starts with the question: does this make writing and publishing better?
                  We don't chase metrics at the expense of the writing experience.
                </p>
              </div>
            </div>
            <div className="about-value">
              <div className="about-value__icon">🌈</div>
              <div>
                <div className="about-value__title">Inclusive by default</div>
                <p className="about-value__desc">
                  All genres, all identities, all pairings. LGBTQ+ stories are not a niche on Verse —
                  they're part of the fabric of the community.
                </p>
              </div>
            </div>
            <div className="about-value">
              <div className="about-value__icon">🔒</div>
              <div>
                <div className="about-value__title">Safe and honest</div>
                <p className="about-value__desc">
                  We take content safety seriously. Our rating system and content guidelines exist to protect
                  younger readers while preserving creative freedom for adults.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Story */}
        <section className="about-section">
          <h2 className="about-h2">How Verse started</h2>
          <p>
            Verse was founded in 2026 by a counseling student with a vision for what a creative writing
            community could be. Not a writer by trade — but someone who understood people, what they need
            to feel seen, and why storytelling matters. That perspective shaped everything about how Verse
            was built.
          </p>
          <p>
            It was built by one person, from the ground up — with feedback and encouragement from a small
            group of early users who believed in the idea and helped shape what Verse has become.
          </p>
        </section>

        {/* CTA */}
        <section className="about-cta">
          <h2 className="about-cta__title">Ready to start writing?</h2>
          <p className="about-cta__sub">Join Verse today — it's free, always.</p>
          <div className="about-cta__actions">
            <Link to="/signup" className="btn btn-primary">Create your account</Link>
            <Link to="/browse" className="btn btn-ghost">Explore stories</Link>
          </div>
        </section>

      </div>
    </div>
  )
}
